import { getLocale } from "../runtime";

const sv_blacklistmessages = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Poff!,Äntligen fri!,Vilken lättnad!,Borta för alltid!,Hejdå!,Sayonara!,Äntligen!,Nu kör vi!,Skönt att slippa!,Befrielse!,Nu släpper vi!,Aldrig mer!,Nystart!,Släpp taget!`
};

const blacklistmessages = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_blacklistmessages(inputs)
	return "blacklistMessages";
};

export { blacklistmessages as "blacklistMessages" };